/** Whether this page runs inside the extension (a new tab or side panel), not the website build. */
export const inExtension = () =>
  "chrome" in globalThis &&
  !!(globalThis as { chrome?: { runtime?: { id?: string } } }).chrome?.runtime?.id;
